/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  /**
   * Colorado Medicaid Form Validation
   * Prevents checkout unless all Medicaid fields are completed and acknowledged
   */
  class MedicaidFormValidator {
    constructor() {
      this.form = document.getElementById("cartForm");
      this.medicaidForm = document.getElementById("checkout-medicaid-form");
      this.errorMessage = document.getElementById("medicaid-error");

      if (this.form && this.medicaidForm) {
        this.init();
      }
    }

    init() {
      // Get all required Medicaid fields
      this.requiredFields = this.medicaidForm.querySelectorAll(
        "[data-medicaid-required]"
      );
      this.termsCheckbox = this.medicaidForm.querySelector(
        "[data-medicaid-terms]"
      );
      
      // Check if the acknowledgment checkbox is enabled via theme settings
      const acknowledgmentWrapper = this.medicaidForm.querySelector("[data-medicaid-acknowledgment-enabled]");
      this.isAcknowledgmentEnabled = acknowledgmentWrapper && acknowledgmentWrapper.dataset.medicaidAcknowledgmentEnabled === "true";

      // Intercept form submission
      this.form.addEventListener("submit", this.handleSubmit.bind(this));

      // Also intercept checkout button clicks (for dynamic checkout buttons)
      document.addEventListener("click", this.handleCheckoutClick.bind(this));

      // Clear error styling on input
      this.requiredFields.forEach((field) => {
        field.addEventListener("input", () => this.clearFieldError(field));
        field.addEventListener("change", () => this.clearFieldError(field));
      });

      if (this.termsCheckbox && this.isAcknowledgmentEnabled) {
        this.termsCheckbox.addEventListener("change", () => this.hideError());
      }
    }

    handleSubmit(event) {
      // Only validate if this is a checkout submission
      const submitter = event.submitter;
      if (submitter && submitter.name === "checkout") {
        if (!this.validateForm()) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }
    }

    handleCheckoutClick(event) {
      const target = event.target;

      // Check if click is on checkout button or related elements
      const checkoutButton = target.closest(
        '[name="checkout"], .cart__checkout, a[href*="/checkout"]'
      );
      const additionalCheckout = target.closest(
        ".additional-checkout-buttons input, .additional-checkout-buttons button"
      );

      if (checkoutButton || additionalCheckout) {
        if (!this.validateForm()) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }
    }

    validateForm() {
      let isValid = true;

      // Validate all required fields
      this.requiredFields.forEach((field) => {
        if (!field.value || field.value.trim() === "") {
          this.showFieldError(field);
          isValid = false;
        } else {
          this.clearFieldError(field);
        }
      });

      // Validate terms checkbox only if acknowledgment is enabled
      if (this.isAcknowledgmentEnabled && this.termsCheckbox && !this.termsCheckbox.checked) {
        isValid = false;
      }

      // Show or hide error message
      if (!isValid) {
        this.showError();
        this.scrollToForm();
      } else {
        this.hideError();
      }

      return isValid;
    }

    showFieldError(field) {
      field.classList.add("error");
    }

    clearFieldError(field) {
      field.classList.remove("error");
    }

    showError() {
      if (this.errorMessage) {
        this.errorMessage.style.display = "block";
      }
    }

    hideError() {
      if (this.errorMessage) {
        this.errorMessage.style.display = "none";
      }
    }

    scrollToForm() {
      if (this.medicaidForm) {
        this.medicaidForm.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }

  // Initialize validator when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => new MedicaidFormValidator()
    );
  } else {
    new MedicaidFormValidator();
  }

  // Re-initialize on Shopify section reload (theme editor)
  document.addEventListener(
    "shopify:section:load",
    () => new MedicaidFormValidator()
  );

  /**
   * PD Measurement Modal Controller
   * Handles the "What is PD?" and "How do I do this?" modals
   * Also injects the trigger buttons and step labels
   * Migrated from old theme
   */
  class PDMeasurementModal {
    constructor() {
      this.modal = document.getElementById("myModal");
      this.modalHow = document.getElementById("myModalHow");

      if (this.modal || this.modalHow) {
        this.init();
      }
    }

    init() {
      this.injectModalTriggers();
      this.bindModalEvents();
      this.bindTriggerButtons();
    }

    /**
     * Inject the modal trigger buttons and step labels into the product page
     * Now handled by UploadFieldHandler.setupUploadElements() which targets specific block IDs
     * This method is kept as a fallback for cases where the specific blocks aren't found
     */
    injectModalTriggers() {
      // Don't inject if buttons already exist (either from this method or UploadFieldHandler)
      if (document.getElementById("openModalBtn")) {
        return;
      }

      // Check if the specific app blocks exist - if so, let UploadFieldHandler handle it
      const pdBlock = document.querySelector(
        '[id*="8dde35e0-8f97-44bf-abfc-c689f0cfb30d"]'
      );
      const prescriptionBlock = document.querySelector(
        '[id*="7394dcc4-c2af-49d2-b1a8-b461eb53db67"]'
      );

      if (pdBlock || prescriptionBlock) {
        console.debug(
          "PD Modal: App blocks found, letting UploadFieldHandler inject triggers"
        );
        return;
      }

      // Fallback: look for product form or variant picker
      let targetContainer =
        document.querySelector("[data-product-form]") ||
        document.querySelector(".product__form") ||
        document.querySelector(".product-form") ||
        document.querySelector(".product__info-container") ||
        document.querySelector(".product__content");

      if (!targetContainer) {
        console.debug(
          "PD Modal: No suitable container found for modal triggers"
        );
        return;
      }

      // Create the PD measurement section container (fallback only)
      const pdSection = document.createElement("div");
      pdSection.id = "pd-measurement-section";
      pdSection.className = "pd-measurement-section";
      pdSection.innerHTML = `
        <p class="f-s-i">Step 3:</p>
        <div class="cl-upload--label">Upload photo for PD measurement</div>
        <div class="button_wrapper">
          <button type="button" id="openModalBtnHow" class="button--underline">How do I do it?</button>
          <button type="button" id="openModalBtn" class="button--underline">What is a PD?</button>
        </div>
      `;

      // Insert after the target container
      targetContainer.insertAdjacentElement("afterend", pdSection);
      console.debug("PD Modal: Trigger buttons injected (fallback method)");
    }

    bindModalEvents() {
      // Close buttons
      document.querySelectorAll(".pd-modal-close").forEach((closeBtn) => {
        closeBtn.addEventListener("click", (e) => {
          const modalId = closeBtn.getAttribute("data-modal-close");
          this.closeModal(modalId);
        });
      });

      // Click outside to close
      [this.modal, this.modalHow].forEach((modal) => {
        if (modal) {
          modal.addEventListener("click", (e) => {
            if (e.target === modal) {
              this.closeModal(modal.id);
            }
          });
        }
      });

      // ESC key to close
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          this.closeAllModals();
        }
      });
    }

    bindTriggerButtons() {
      // What is PD button
      const openModalBtn = document.getElementById("openModalBtn");
      if (openModalBtn) {
        openModalBtn.addEventListener("click", (e) => {
          e.preventDefault();
          this.openModal("myModal");
        });
      }

      // How to measure PD button
      const openModalBtnHow = document.getElementById("openModalBtnHow");
      if (openModalBtnHow) {
        openModalBtnHow.addEventListener("click", (e) => {
          e.preventDefault();
          this.openModal("myModalHow");
        });
      }
    }

    openModal(modalId) {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = "block";
        document.body.style.overflow = "hidden";
      }
    }

    closeModal(modalId) {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = "none";
        document.body.style.overflow = "";
      }
    }

    closeAllModals() {
      document.querySelectorAll(".pd-modal").forEach((modal) => {
        modal.style.display = "none";
      });
      document.body.style.overflow = "";
    }
  }

  /**
   * Upload Field Handler
   * Manages the movement and injection of upload elements for third-party apps
   * Migrated from old theme
   */
  class UploadFieldHandler {
    constructor() {
      this.init();
    }

    init() {
      // Wait for DOM to be fully loaded before manipulating elements
      if (document.readyState === "complete") {
        this.setupUploadElements();
        this.setupRadioButtonHandlers();
      } else {
        window.addEventListener("load", () => {
          this.setupUploadElements();
          this.setupRadioButtonHandlers();
        });
      }

      // Listen for options rendered event from third-party apps
      window.addEventListener(
        "options:rendered",
        (e) => {
          this.handleOptionsRendered(e);
        },
        { once: true }
      );

      // Periodically check for inject elements (for dynamic content)
      this.startInjectWatcher();
    }

    setupUploadElements() {
      // Find Shopify app blocks that contain the Upload Lift app by looking for blocks
      // with IDs containing the block UUID from the template
      // These UUIDs are set in product.json:
      // - 7394dcc4-c2af-49d2-b1a8-b461eb53db67 (prescription upload)
      // - 8dde35e0-8f97-44bf-abfc-c689f0cfb30d (pd upload)

      const prescriptionBlock = document.querySelector(
        '[id*="7394dcc4-c2af-49d2-b1a8-b461eb53db67"]'
      );
      const pdBlock = document.querySelector(
        '[id*="8dde35e0-8f97-44bf-abfc-c689f0cfb30d"]'
      );

      // Inject Step labels into the app blocks if they exist
      if (prescriptionBlock && !prescriptionBlock.querySelector(".f-s-i")) {
        const step2Label = document.createElement("p");
        step2Label.className = "f-s-i";
        step2Label.textContent = "Step 2:";
        prescriptionBlock.insertBefore(
          step2Label,
          prescriptionBlock.firstChild
        );
        console.debug("Injected Step 2 label into prescription block");
      }

      if (pdBlock && !pdBlock.querySelector(".f-s-i")) {
        // Create the PD section with buttons and step label
        const pdContent = document.createElement("div");
        pdContent.className = "pd-step-content";
        pdContent.innerHTML = `
          <p class="f-s-i">Step 3:</p>
          <div class="cl-upload--label">Upload photo for PD measurement</div>
          <div class="button_wrapper">
            <button type="button" id="openModalBtnHow" class="button--underline">How do I do it?</button>
            <button type="button" id="openModalBtn" class="button--underline">What is a PD?</button>
          </div>
        `;

        // Only insert if buttons don't already exist
        if (!pdBlock.querySelector("#openModalBtn")) {
          pdBlock.insertBefore(pdContent, pdBlock.firstChild);
          console.debug("Injected PD content into pd block");

          // Re-bind modal events for the new buttons
          this.bindPDModalButtons();
        }
      }
      
      // Inject upload info into prescription block
      if(prescriptionBlock && !prescriptionBlock.querySelector(".cl-upload--info")) {
        this.injectUploadInfo(prescriptionBlock);
      }

      // Inject upload info into PD block
      if(pdBlock && !pdBlock.querySelector(".cl-upload--info")) {
        this.injectUploadInfo(pdBlock);
      }

      // Look for upload elements by data-option attribute (for third-party app)
      // NOTE: Don't move these elements - let the app's own JavaScript handle positioning
      // The app expects them to be in specific blocks by ID
      const uploadElementPD = document.querySelector('div[data-option="pd"]');
      const uploadElementOption3 = document.querySelector(
        'div[data-option="option_3"]'
      );

      // If the app's JavaScript hasn't moved them yet, and the blocks exist,
      // move them into the correct blocks
      if (uploadElementPD && pdBlock && !pdBlock.contains(uploadElementPD)) {
        pdBlock.appendChild(uploadElementPD);
        console.debug("Moved PD upload element into pd block");
      }

      if (
        uploadElementOption3 &&
        prescriptionBlock &&
        !prescriptionBlock.contains(uploadElementOption3)
      ) {
        prescriptionBlock.appendChild(uploadElementOption3);
        console.debug(
          "Moved prescription upload element into prescription block"
        );
      }
    }

    injectUploadInfo(block) {
      const uploadInfo = document.createElement("div");
      uploadInfo.className = "cl-upload--info body-small";
      uploadInfo.innerHTML = `
        <p>Your prescription is securely stored and reviewed by licensed opticians. Accepted file formats (PDF, JPG, PNG, HEIC); Maximum file size: 50MB</p>
      `;
      block.appendChild(uploadInfo);
    }

    /**
     * Bind click events to PD modal buttons
     */
    bindPDModalButtons() {
      const openModalBtn = document.getElementById("openModalBtn");
      const openModalBtnHow = document.getElementById("openModalBtnHow");
      const modal = document.getElementById("myModal");
      const modalHow = document.getElementById("myModalHow");

      if (openModalBtn && modal) {
        openModalBtn.addEventListener("click", (e) => {
          e.preventDefault();
          modal.style.display = "block";
          document.body.style.overflow = "hidden";
        });
      }

      if (openModalBtnHow && modalHow) {
        openModalBtnHow.addEventListener("click", (e) => {
          e.preventDefault();
          modalHow.style.display = "block";
          document.body.style.overflow = "hidden";
        });
      }
    }

    /**
     * Setup handlers for third-party app radio buttons
     * Handles radio buttons with class .cl-po--input from custom product options apps
     * Migrated from old theme's product.js
     */
    setupRadioButtonHandlers() {
      // Use event delegation on document to handle dynamically injected radio buttons
      // This ensures we catch radio buttons added by third-party apps after page load
      if (!this.radioHandlerBound) {
        this.radioHandlerBound = true;

        document.addEventListener("change", (e) => {
          // Check if the changed element is a custom product option radio button
          if (!e.target.matches(".cl-po--input")) {
            return;
          }

          this.handleRadioChange(e.target.value);
        });

        // Also listen for click events as some frameworks trigger click but not change
        document.addEventListener("click", (e) => {
          if (!e.target.matches(".cl-po--input")) {
            return;
          }
          // Small delay to let the radio button state update
          setTimeout(() => {
            if (e.target.checked) {
              this.handleRadioChange(e.target.value);
            }
          }, 10);
        });
      }

      // Check for initial state if radio buttons already exist
      this.applyInitialRadioState();

      // Find and setup the append-question container if it exists
      const appendQuestionDiv = document.getElementById("append-question");
      if (appendQuestionDiv) {
        this.setupAppendQuestionContent(appendQuestionDiv);
      }
    }

    /**
     * Handle radio button change - updates visibility of upload blocks
     */
    handleRadioChange(value) {
      // Query elements fresh each time to handle dynamically added content
      const pdBlock = document.querySelector(
        '[id*="8dde35e0-8f97-44bf-abfc-c689f0cfb30d"]'
      );
      const prescriptionBlock = document.querySelector(
        '[id*="7394dcc4-c2af-49d2-b1a8-b461eb53db67"]'
      );

      const stepElements = document.querySelectorAll(".f-s-i");
      const prescriptionStepElement = document.querySelector(".prescription-step");

      // Handle visibility based on customer type selection
      // Normalize value for comparison: replace all ’ (U+2019) with ' (U+0027)
      const normalizedValue = value.replace(/\u2019/g, "'");

      const OPT_PREV_CUST_ON_FILE =
        "I am a previous customer of Children's Optical with a current eyeglass prescription on file.";
      const OPT_PREV_CUST_NEW_RX =
        "I am a previous customer of Children's Optical with a NEW eyeglass prescription to upload.";

      if (normalizedValue === OPT_PREV_CUST_ON_FILE) {
        // Previous customer with prescription on file - hide upload sections
        if (pdBlock) pdBlock.style.display = "none";
        if (prescriptionBlock) prescriptionBlock.style.display = "none";
        stepElements.forEach((el) => el.classList.add("displayNone"));
        prescriptionStepElement.classList.add("no-step");
      } else if (normalizedValue === OPT_PREV_CUST_NEW_RX) {
        // Previous customer with new prescription - show prescription upload only
        if (pdBlock) pdBlock.style.display = "none";
        if (prescriptionBlock) prescriptionBlock.style.display = "block";
        stepElements.forEach((el) => el.classList.remove("displayNone"));
        prescriptionStepElement.classList.remove("no-step");
        stepElements.forEach((el) => {
          // Only show Step 2 label, hide Step 3
          if (el.textContent.includes("Step 2")) {
            el.classList.remove("displayNone");
          } else if (el.textContent.includes("Step 3")) {
            el.classList.add("displayNone");
          }
        });       
      } else {
        // New customer - show both upload sections
        if (pdBlock) pdBlock.style.display = "block";
        if (prescriptionBlock) prescriptionBlock.style.display = "block";
        stepElements.forEach((el) => el.classList.remove("displayNone"));
        prescriptionStepElement.classList.remove("no-step");
      }
    }

    /**
     * Setup content for the append-question div
     * This injects medicaid-related radio button options into the product form
     */
    setupAppendQuestionContent(container) {
      // Check if radio buttons already exist in this container - prevent duplicates
      if (container.querySelector(".cl-po--input")) {
        console.debug(
          "Radio buttons already in append-question, skipping injection"
        );
        return;
      }

      // Check if content is already injected (fallback medicaid form)
      if (container.querySelector(".medicaid-inline-question")) {
        return;
      }

      // Check if there are any radio buttons from third-party apps
      // Only look for radio buttons that are NOT already inside append-question
      const customOptionRadios = document.querySelectorAll(
        '.cl-po--input[type="radio"]'
      );

      // Filter out any that are already in the container
      const radiosOutsideContainer = Array.from(customOptionRadios).filter(
        (radio) => !container.contains(radio)
      );

      if (radiosOutsideContainer.length > 0) {
        // Don't clone - the third-party app or startInjectWatcher will handle moving
        // Just log that we found radio buttons elsewhere
        console.debug(
          "Radio buttons found outside append-question, waiting for proper injection"
        );
        return;
      } else if (customOptionRadios.length > 0) {
        // Radio buttons already in container, nothing to do
        console.debug("Radio buttons already positioned correctly");
        return;
      } else {
        // If no third-party radio buttons found, create a medicaid question form
        // This provides fallback functionality similar to popup-medicaid
        const medicaidCookie = this.getCookie("medicaidCustomer");

        if (!medicaidCookie) {
          // container.innerHTML = `
          //   <div class="medicaid-inline-question">
          //     <label class="medicaid-question-label">Are you using Colorado Medicaid for this purchase?</label>
          //     <div class="medicaid-question-options">
          //       <label class="medicaid-option">
          //         <input type="radio" name="medicaid_inline" value="yes" class="medicaid-radio">
          //         <span>Yes</span>
          //       </label>
          //       <label class="medicaid-option">
          //         <input type="radio" name="medicaid_inline" value="no" class="medicaid-radio">
          //         <span>No</span>
          //       </label>
          //     </div>
          //   </div>
          // `;

          // Add event listeners for the inline medicaid question
          const radios = container.querySelectorAll(".medicaid-radio");
          radios.forEach((radio) => {
            radio.addEventListener("change", (e) => {
              this.setCookie("medicaidCustomer", e.target.value, 365);
              console.debug("Medicaid preference set:", e.target.value);
            });
          });
        }
      }
    }

    // Cookie utility functions
    setCookie(name, value, days) {
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + days);
      const cookieValue =
        encodeURIComponent(value) +
        (days ? "; expires=" + expirationDate.toUTCString() : "");
      document.cookie = name + "=" + cookieValue + "; path=/";
    }

    getCookie(name) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    }

    handleOptionsRendered(e) {
      console.debug("Options rendered", e.detail);

      // Handle any custom option manipulations here
      const optionEl = document.querySelector('[data-option="NAME_HERE"]');
      if (optionEl) {
        console.debug("Found option element", optionEl);
        const inputEl = optionEl.querySelector("input");
        if (inputEl) {
          console.debug("Found option input", inputEl);
          // Custom value manipulation can be done here if needed
        }
      }

      // Re-setup radio button handlers after options are rendered
      this.setupRadioButtonHandlers();
    }

    startInjectWatcher() {
      // Watch for elements that need to be injected into specific containers
      // The third-party app renders radio buttons asynchronously (Vue/React),
      // so we need to wait for them to actually exist
      const watchInterval = setInterval(() => {
        const injectDiv = document.querySelector(".inject");
        const appendQuestionDiv = document.getElementById("append-question");

        // First, check if radio buttons exist ANYWHERE on the page
        const radioButtonsInInject = injectDiv
          ? injectDiv.querySelectorAll(".cl-po--input")
          : [];
        const radioButtonsInAppend = appendQuestionDiv
          ? appendQuestionDiv.querySelectorAll(".cl-po--input")
          : [];

        // If radio buttons are already in append-question, just hide the inject div
        if (radioButtonsInAppend.length > 0) {
          if (injectDiv) {
            injectDiv.style.display = "none";
          }
          console.debug(
            "Radio buttons found in #append-question, hidden .inject div"
          );
          // Apply initial visibility state based on selected radio
          this.applyInitialRadioState();
          clearInterval(watchInterval);
          return;
        }

        // If radio buttons are in the inject div, move the parent option container
        if (radioButtonsInInject.length > 0 && appendQuestionDiv) {
          // Find the closest .cl-po--option or .cl-po--wrapper container
          const radioOptions =
            injectDiv.querySelector(".cl-po--option") ||
            injectDiv.querySelector(".cl-po--wrapper");

          if (radioOptions) {
            // Move the actual element instead of cloning to prevent duplicates
            appendQuestionDiv.appendChild(radioOptions);
            injectDiv.style.display = "none";
            console.debug(
              "Moved radio buttons from .inject to #append-question"
            );
            // Apply initial visibility state based on selected radio
            this.applyInitialRadioState();
            clearInterval(watchInterval);
            return;
          }
        }

        // Don't hide .inject until we've confirmed radio buttons exist somewhere
        // The app might still be rendering them
      }, 500); // Check every 500ms for faster response

      // Stop watching after 30 seconds to prevent infinite loops
      setTimeout(() => clearInterval(watchInterval), 30000);
    }

    /**
     * Apply initial visibility state based on currently selected radio button
     * This handles page load when a radio might already be selected
     */
    applyInitialRadioState() {
      const selectedRadio = document.querySelector(".cl-po--input:checked");

      if (selectedRadio) {
        console.debug("Applying initial radio state:", selectedRadio.value);
        this.handleRadioChange(selectedRadio.value);
      }
    }
  }

  /**
   * Cart Popup
   * Modal shown on every cart page load. 
   * Reuses theme modal styles and close patterns.
   */
  class CartPopup extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector("[data-cart-popup-dialog]");
    }

    connectedCallback() {
      if (!this.dialog) return;

      this.closePopup = this.closePopup.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBackdropClick = (e) => {
        if (e.target === this.dialog) this.closePopup();
      };

      // Close buttons
      this.querySelectorAll("[data-cart-popup-close]").forEach((btn) => {
        btn.addEventListener("click", this.closePopup);
      });

      // Click on dialog backdrop (the dialog element itself)
      this.dialog.addEventListener("click", this.handleBackdropClick);

      // ESC key
      this.dialog.addEventListener("keydown", this.handleKeydown);

      // Show on load
      this.openPopup();
    }

    disconnectedCallback() {
      this.querySelectorAll("[data-cart-popup-close]").forEach((btn) => {
        btn.removeEventListener("click", this.closePopup);
      });
      this.dialog?.removeEventListener("click", this.handleBackdropClick);
      this.dialog?.removeEventListener("keydown", this.handleKeydown);
    }

    openPopup() {
      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
      if (this.dialog.hasAttribute("data-scroll-lock-required")) {
        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
      }
    }

    closePopup() {
      if (typeof this.dialog.close === "function") {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute("open");
      }
      if (
        this.dialog.hasAttribute("data-scroll-lock-required") &&
        window.theme?.hasOpenModals &&
        !window.theme.hasOpenModals()
      ) {
        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
      }
    }

    handleKeydown(e) {
      if (e.code === "Escape") {
        e.preventDefault();
        this.closePopup();
      }
    }
  }

  if (!customElements.get("cart-popup")) {
    customElements.define("cart-popup", CartPopup);
  }

  // Initialize PD Measurement Modal
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      new PDMeasurementModal();
      new UploadFieldHandler();
    });
  } else {
    new PDMeasurementModal();
    new UploadFieldHandler();
  }

  // Re-initialize on Shopify section reload (theme editor)
  document.addEventListener("shopify:section:load", () => {
    new PDMeasurementModal();
    new UploadFieldHandler();
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
